/**
 * Sorting class used to explain sort options to the api when retrieving events
 */

import { SortOrder, SortProperty } from "../enums";

export class Sorting {
  constructor(public sortBy: SortProperty, public sortOrder: SortOrder) {}
}
